// ##### 25-04-17 Komarov: Компонент для встраивания Google Tag на страницу сайта

// ##### Komarov 2025-07-12
import { useEffect } from 'react';

// ##### Komarov 2025-07-14
const GtagInit = () => {
  // ##### Komarov 2025-07-12
  useEffect(() => {
    const scriptSrc = process.env.REACT_APP_GTAG_SCRIPT_SRC;
    const gtagId = process.env.REACT_APP_GTAG_ID;

    if (!scriptSrc || !gtagId) {
      console.warn('Google Analytics environment variables are not set!');
      return;
    }

    // Inject the gtag script
    const script = document.createElement('script');
    script.async = true;
    script.src = scriptSrc;
    document.head.appendChild(script);

    // Inject the gtag config
    const inlineScript = document.createElement('script');
    inlineScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${gtagId}');
    `;
    document.head.appendChild(inlineScript);

    // Cleanup on unmount
    return () => {
      document.head.removeChild(script);
      document.head.removeChild(inlineScript);
    };
  }, []);

  return null; // This component does not render anything
};

// ##### 25-05-02 Komarov
export default GtagInit;
